import { Col } from 'react-bootstrap'
import styled from 'styled-components'
export const LeftCol = styled(Col)`
    @media (min-width: 576px) {
        height: 100vh;
        overflow-y: scroll;
    }
    div:last-child{
        padding-bottom:.25rem;
    }
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px ${({ theme }) => theme.color.second}; 
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.color.third}; 
        border-radius: 10px;
    }
`
export const MiddleCol = styled(Col)`
    @media (min-width: 576px) {
        height: 100vh;
        overflow-y: scroll;
    }
    div:last-child{
        padding-bottom:.5rem
    }
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px ${({ theme }) => theme.color.second}; 
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.color.third}; 
        border-radius: 10px;
    }
`
export const RightCol = styled(Col)`
    @media (min-width: 1200px) {
        height: 100vh;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    div:last-child{
        padding-bottom:.5rem
    }
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px ${({ theme }) => theme.color.second}; 
        border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.color.third}; 
        border-radius: 10px;
    }
`